export default function initVimeoModal() {
  const modal = document.getElementById("vimeoModal");
  if (!modal) return;

  const playerContainer = modal.querySelector(".vimeo-player");
  const triggers = document.querySelectorAll(".vimeo-modal[data-src]");

  if (!playerContainer || !triggers.length) return;

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const src = trigger.dataset.src;
      if (!src) return;

      // Create fresh iframe each time
      playerContainer.innerHTML = "";
      const iframe = document.createElement("iframe");
      iframe.src = `${src}?autoplay=1&title=0&byline=0&portrait=0`;
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture");
      iframe.setAttribute("allowfullscreen", "");
      playerContainer.appendChild(iframe);
    });
  });

  // Stop video on modal close
  const closeBtn = modal.querySelector(".modal-close");
  function stopVideo() {
    playerContainer.innerHTML = "";
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", stopVideo);
  }
  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      stopVideo();
    }
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("show")) {
      stopVideo();
    }
  });
}
